import { AccountDTO } from '@addsome/dtos/dist'
import defaultAvatarImg from '../assets/images/avatar_default.png'

export default function getProfilePicture(account: AccountDTO | null) {
  return (account && account.profilePicture && account.profilePicture.url) || defaultAvatarImg
}
